import { createStorefrontApiClient } from '@shopify/storefront-api-client'
import isomorphicFetch from 'isomorphic-fetch'

export const storeFrontApiClient = createStorefrontApiClient({
  storeDomain: process.env.GATSBY_SHOPIFY_STORE_URL,
  apiVersion: '2025-07',
  publicAccessToken: process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
  customFetchApi: isomorphicFetch,
})
